// Submit Your Screening — the Film Clubs intake form on its OWN page (Josh
// 2026-08-12: the embedded form made the portal read like an open mic; the
// listings page stays curated, submission lives here behind a small link).
// Netlify Form (static twin in public/index.html, name "submit-screening") →
// email notification → Josh approves → row entered by script.
import React, { useState } from 'react';

const GOLD = '#8b6914';
const CREAM = '#faf7f2';
const INK = '#2a2520';

const inputStyle = {
  padding: '8px 12px', border: '1px solid #d4cec4', borderRadius: '4px',
  fontSize: '0.85rem', width: '100%', boxSizing: 'border-box', background: '#fff',
};
const labelStyle = { display: 'block', fontWeight: '600', color: INK, fontSize: '0.8rem', marginBottom: '4px' };

export default function SubmitScreening() {
  const [formState, setFormState] = useState('idle'); // idle | sending | sent | error

  // Netlify Forms only exist on the deployed site — on dev hosts the POST has no
  // receiver, so local QA simulates the success path (clearly labeled).
  const isLocalDev = typeof window !== 'undefined' && /^(localhost|192\.168\.|10\.|127\.)/.test(window.location.hostname);

  async function handleSubmit(e) {
    e.preventDefault();
    setFormState('sending');
    const form = e.target;
    const body = new URLSearchParams(new FormData(form)).toString();
    if (isLocalDev) {
      await new Promise((r) => setTimeout(r, 600));
      setFormState('sent');
      form.reset();
      return;
    }
    try {
      const res = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
      });
      if (!res.ok) throw new Error(`submit failed (${res.status})`);
      setFormState('sent');
      form.reset();
    } catch {
      setFormState('error');
    }
  }

  return (
    <div style={{ maxWidth: '640px', margin: '0 auto', padding: '24px 16px', color: INK }}>
      <a href="/film-clubs" style={{ color: GOLD, textDecoration: 'none', fontSize: '0.85rem' }}>← Back to Clubs &amp; Community Screenings</a>
      <h1 style={{ fontFamily: 'Cinzel, serif', fontSize: '1.6rem', margin: '16px 0 4px' }}>Submit Your Screening</h1>
      <p style={{ fontSize: '0.9rem', color: '#6b6255', margin: '0 0 20px' }}>
        Hosting a repertory screening at a library, bar, gallery, rooftop, or anywhere that isn't a movie
        theater? Tell us about it. Every listing on Film Revival is reviewed and curated by hand —
        approved events appear on the Clubs &amp; Community Screenings page and the film's own page, and reach watchlist
        subscribers who've saved that film. We list revival &amp; repertory screenings only (no new
        releases or premieres). Allow a day or two for review.
      </p>
      <div style={{ background: CREAM, border: '1px solid #d4cec4', borderRadius: '8px', padding: '20px' }}>
        {formState === 'sent' ? (
          <p style={{ color: '#4CAF50', fontWeight: 600 }}>
            Got it — thank you! We review every submission and it'll appear on the Clubs &amp; Community Screenings page once approved.
            {isLocalDev && <span style={{ display: 'block', color: '#b8860b', fontWeight: 400, fontSize: '0.8rem', marginTop: '6px' }}>(local test mode — nothing was actually sent; real submissions work once deployed)</span>}
          </p>
        ) : (
          <form name="submit-screening" method="POST" data-netlify="true" netlify-honeypot="bot-field" onSubmit={handleSubmit}>
            <input type="hidden" name="form-name" value="submit-screening" />
            <p style={{ display: 'none' }}><label>Don't fill this out: <input name="bot-field" /></label></p>
            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '10px', marginBottom: '10px' }}>
              <div><label style={labelStyle}>Film title *</label><input style={inputStyle} name="film-title" required /></div>
              <div><label style={labelStyle}>Year</label><input style={inputStyle} name="film-year" placeholder="1975" /></div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px' }}>
              <div><label style={labelStyle}>Date *</label><input style={inputStyle} type="date" name="event-date" required /></div>
              <div><label style={labelStyle}>Start time *</label><input style={inputStyle} type="time" name="event-time" required /></div>
            </div>
            <div style={{ marginBottom: '10px' }}>
              <label style={labelStyle}>Venue name &amp; neighborhood *</label>
              <input style={inputStyle} name="venue" placeholder="e.g. The Owl's Head, Bay Ridge" required />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px' }}>
              <div><label style={labelStyle}>Your club / series name</label><input style={inputStyle} name="series" placeholder="e.g. Basement Cinema Club" /></div>
              <div><label style={labelStyle}>Ticket / RSVP link</label><input style={inputStyle} name="ticket-link" placeholder="https://…" /></div>
            </div>
            <div style={{ marginBottom: '10px' }}>
              <label style={labelStyle}>Your email * <span style={{ fontWeight: 400, color: '#6b6255' }}>(so we can confirm details — never published)</span></label>
              <input style={inputStyle} type="email" name="contact-email" required />
            </div>
            <div style={{ marginBottom: '14px' }}>
              <label style={labelStyle}>Anything else</label>
              <textarea style={{ ...inputStyle, minHeight: '60px' }} name="notes" placeholder="Format (16mm? VHS?), double bill, live score…" />
            </div>
            <button type="submit" disabled={formState === 'sending'}
              style={{ padding: '10px 22px', background: GOLD, color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '0.9rem', opacity: formState === 'sending' ? 0.7 : 1 }}>
              {formState === 'sending' ? 'Sending…' : 'Submit screening'}
            </button>
            {formState === 'error' && <p style={{ color: '#cc4444', fontSize: '0.85rem' }}>Something went wrong — email us instead at filmrevivalnyc@gmail.com.</p>}
          </form>
        )}
      </div>
    </div>
  );
}
